import { Panel, dur } from "./util";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const PageHeat = ({ pages }) => {
  const max = Math.max(1, ...pages.map((p) => p.dwell_s));
  return (
    <Panel title="Where he spends time" testid="insights-page-heat">
      {!pages.length && <p className="text-sm text-white/45">No page data yet.</p>}
      <ul className="space-y-2.5">
        {pages.map((p, i) => (
          <li key={p.page} data-testid={`heat-page-${i}`}>
            <div className="flex justify-between text-xs"><span className="text-white/85 truncate">{p.page}</span>
              <span className="font-mono text-white/50 shrink-0 ml-2">{dur(p.dwell_s)} · {p.visits}v · {p.clicks}c{p.errors ? <span className="text-red-400"> · {p.errors}err</span> : ""}</span></div>
            <div className="h-1.5 bg-white/5 mt-1 overflow-hidden">
              <div className="h-full bg-gradient-to-r from-brand/60 to-brand origin-left animate-in slide-in-from-left duration-700" style={{ width: `${Math.max(3, (100 * p.dwell_s) / max)}%` }} />
            </div>
          </li>
        ))}
      </ul>
    </Panel>
  );
};

export const HourHeat = ({ hours }) => {
  const max = Math.max(1, ...hours.flat());
  return (
    <Panel title="Activity heatmap · day × hour (UTC)" testid="insights-hour-heat">
      <div className="overflow-x-auto">
        <div className="grid gap-[3px] min-w-[560px]" style={{ gridTemplateColumns: "34px repeat(24, 1fr)" }}>
          <span />
          {Array.from({ length: 24 }, (_, h) => <span key={h} className="font-mono text-[8px] text-white/30 text-center">{h % 3 === 0 ? h : ""}</span>)}
          {hours.map((row, d) => [
            <span key={`d${d}`} className="font-mono text-[9px] text-white/40 self-center">{DAYS[d]}</span>,
            ...row.map((v, h) => (
              <span key={`${d}-${h}`} title={`${DAYS[d]} ${h}:00 · ${v} events`} className="aspect-square transition-transform hover:scale-125"
                style={{ background: v ? `rgb(var(--brand-rgb) / ${0.12 + (0.88 * v) / max})` : "rgba(255,255,255,0.03)" }} data-testid={`hour-cell-${d}-${h}`} />
            )),
          ])}
        </div>
      </div>
    </Panel>
  );
};
